import { render, staticRenderFns } from "./AddScopeComp.vue?vue&type=template&id=95fe6d18"
import script from "./AddScopeComp.vue?vue&type=script&lang=js"
export * from "./AddScopeComp.vue?vue&type=script&lang=js"
import style0 from "./AddScopeComp.vue?vue&type=style&index=0&id=95fe6d18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports